import { useEffect, useMemo } from "react";
import { useTemplatesStatusStore } from "../store/useTemplatesStatusStore";
import { useTemplateEditorStore } from "../store/useTemplateEditorStore";
import { ItemType } from "../types";

export const useDeleteItem = (currentItem: ItemType | undefined) => {
  const { deleteImage, deleteVideo, deleteCustomText } = useTemplateEditorStore(
    (state) => ({
      deleteImage: state.deleteImage,
      deleteVideo: state.deleteVideo,
      deleteCustomText: state.deleteCustomText,
    })
  );

  const { addTemplateUpdate } = useTemplatesStatusStore((state) => ({
    addTemplateUpdate: state.addTemplateUpdate,
  }));

  const handlers = useMemo(
    () => ({
      Image: deleteImage,
      Video: deleteVideo,
      CustomText: deleteCustomText,
    }),
    [deleteImage, deleteVideo, deleteCustomText]
  );

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!["Delete", "Backspace"].includes(e.key)) {
        return;
      }

      const handlerFunction =
        handlers[currentItem?.type as keyof typeof handlers];

      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement ||
        !currentItem?.id ||
        !handlerFunction
      ) {
        return;
      }

      e.preventDefault();

      handlerFunction(currentItem.id);
      addTemplateUpdate();
    };

    globalThis.addEventListener("keydown", handleKeyDown);
    return () => globalThis.removeEventListener("keydown", handleKeyDown);
  }, [addTemplateUpdate, currentItem?.id, currentItem?.type, handlers]);
};
